//import { Ui } from "./../Ui";
import { Result, PagedResult } from "./../models/Results";
import Axios, { AxiosRequestConfig } from "axios";
//import { transformUrl } from "domain-wait";
import jsonToUrl from "json-to-url";
import * as AuthorizationStore from '../store/Authorization';
import { AzureRefreshTokenRequest, GetAzureClientTokenRequest } from "./AuthenticationService";
import { ImpactPartner } from "../models/ImpactPartner";

let ajaxRequests = [];
export interface IRequestOptions {
    url: string;
    data?: any;
    method: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
}

export interface ISendFormDataOptions {
    url: string;
    data: FormData;
    method: "POST" | "PUT" | "PATCH";
}

/**
 * Represents base class of the isomorphic service.
 */
export abstract class ServiceBase {

    /**
     * Make request with JSON data.
     * @param opts
     */
    public static async requestJson<T>(opts: IRequestOptions, preProcessJson?: (data: any) => any, useMultiPart?: boolean, cancelPendingRequests?: boolean): Promise<Result<T>> {
        var axiosResult = null;
        var result = null;

        if (ajaxRequests && ajaxRequests.length > 0 && cancelPendingRequests && opts && opts.url && opts.url.toLocaleLowerCase() === "/api/ProductInventory/SearchInventory/".toLocaleLowerCase()) {
            ajaxRequests.map(e => {
                try {
                    e.cancel();
                }
                catch { }
            });
            ajaxRequests = [];
        }

        //opts.url = transformUrl(opts.url); // Allow requests also for the Node.

        var processQuery = (url: string, data: any): string => {
            if (data) {
                return `${url}?${jsonToUrl(data)}`;
            }
            return url;
        };

        var axiosRequestConfig: AxiosRequestConfig = {
            headers: {}
        };

        if (opts && opts.url && opts.url.toLocaleLowerCase() === "/api/ProductInventory/SearchInventory/".toLocaleLowerCase()) {
            var cancelToken = Axios.CancelToken.source()
            ajaxRequests.push(cancelToken);
            axiosRequestConfig.cancelToken = cancelToken.token;
        }

        const partner = AuthorizationStore.getImpactPartnerFromLocalStorage();
        if (partner && partner.Id) {
            axiosRequestConfig.headers.Partner = partner.Id;
        }
        
        let azureToken = AuthorizationStore.getAzureTokenFromLocalStorage();
        if (azureToken !== null) {
            let token = azureToken.access_token;

            if (Date.now() >= azureToken.expires_on * 1000) {
                try {
                    if (!azureToken.refresh_token) {
                        AuthorizationStore.removeFromLocalStorage('azure_ad_token');
                        AuthorizationStore.removeFromLocalStorage('current_user');
                        AuthorizationStore.removeFromLocalStorage('current_partner');
                        document.location.assign("/login");
                        return;
                    }

                    let data: AzureRefreshTokenRequest = {
                        impactPartnerId: partner?.Id,
                        refreshToken: azureToken.refresh_token
                    }

                    axiosResult = await Axios.post(`/api/Authorization/refreshAzureToken/`, data, axiosRequestConfig);
                    AuthorizationStore.saveAzureTokenToLocalStorage(axiosResult.data.token);
                    token = axiosResult.data.token.access_token;

                } catch {
                    AuthorizationStore.removeFromLocalStorage('azure_ad_token');
                    AuthorizationStore.removeFromLocalStorage('current_user');
                    AuthorizationStore.removeFromLocalStorage('current_partner');
                    document.location.assign("/login");
                }
            }

            axiosRequestConfig.headers.Authorization = 'Bearer '.concat(token);
        }
        else {
            AuthorizationStore.removeFromLocalStorage('azure_ad_token');
            AuthorizationStore.removeFromLocalStorage('current_user');
            AuthorizationStore.removeFromLocalStorage('current_partner');
            document.location.assign("/login");
        }

        var currentUser = AuthorizationStore.getUserFromLocalStorage();

        if (currentUser) {
            axiosRequestConfig.headers["INET-User"] = currentUser.UserId;
            axiosRequestConfig.headers["INET-User-Name"] = normalizeToASCII(currentUser.UserName);
        }

        var payload = opts.data;

        if (useMultiPart === true) {
            axiosRequestConfig.headers.ContentType = 'multipart/form-data';
            payload = convertModelToFormData(opts.data);            
        }            

        try {
            switch (opts.method) {
                case "GET":
                    axiosResult = await Axios.get(processQuery(opts.url, payload), axiosRequestConfig);
                    break;
                case "POST":
                    axiosResult = await Axios.post(opts.url, payload, axiosRequestConfig);
                    break;
                case "PUT":
                    axiosResult = await Axios.put(opts.url, payload, axiosRequestConfig);
                    break;
                case "PATCH":
                    axiosResult = await Axios.patch(opts.url, payload, axiosRequestConfig);
                    break;
                case "DELETE":
                    axiosResult = await Axios.delete(processQuery(opts.url, payload), axiosRequestConfig);
                    break;
            }

            var rowData = preProcessJson
                ? preProcessJson(axiosResult.data)
                : axiosResult.data;
            //if (opts && opts.url && opts.url.toLocaleLowerCase() === "/api/Cart/GetUserCarts".toLocaleLowerCase()) {
            //    rowData.forEach((data) => {
            //        data.Items = JSON.parse(data.Items)
            //    })
            //}
            result = new Result(rowData, null, null, 200);
            //result = new Result(axiosResult.data, ...axiosResult.data.errors);
        } catch (error) {
            console.warn('Service Base error catch', error);
            if (error.response && error.response.status === 400) {

                console.warn('processing bad request:', error.response);
                return this.createBadRequestResult(error);

            } else if (error.response && error.response.status === 401) {
                console.warn('processing unauthorized request:', error.response);

                AuthorizationStore.removeFromLocalStorage('azure_ad_token');
                AuthorizationStore.removeFromLocalStorage('current_user');
                AuthorizationStore.removeFromLocalStorage('current_partner');

                document.location.assign("/login");
            } else {
                console.warn('service unproceessed responce:', error);
            }

            if (error.response) {
                console.log(error.response.data);
                console.log('general error', error.response.data['']);
            }

            result = new Result(null, null, error.message, error.response ? error.response.status : error.__proto__.__CANCEL__ ? 499 : undefined); 
            console.log(result)
        }

        if (result.hasErrors) {
            console.log('ServiceBase: Server error');
            //Ui.showErrors('Server error');
        }

        return result;
    }

    /**
     * Make request with JSON data.
     * @param opts
     */
    public static async requestClietAuthJson<T>(partner: ImpactPartner, opts: IRequestOptions, preProcessJson?: (data: any) => any, useMultiPart?: boolean): Promise<Result<T>> {
        var axiosResult = null;
        var result = null;

        var processQuery = (url: string, data: any): string => {
            if (data) {
                return `${url}?${jsonToUrl(data)}`;
            }
            return url;
        };

        var axiosRequestConfig: AxiosRequestConfig = {
            headers: {}
        };

        const currentPartner = AuthorizationStore.getImpactPartnerFromLocalStorage();
        if (currentPartner && currentPartner.Id) {
            axiosRequestConfig.headers.Partner = currentPartner.Id;
        }

        let azureToken = AuthorizationStore.getAzureTokenFromLocalStorage();
        if (azureToken !== null) {
            let token = azureToken.access_token;

            if (Date.now() >= azureToken.expires_on * 1000) {
                try {
                    if (!azureToken.refresh_token) {
                        AuthorizationStore.removeFromLocalStorage('azure_ad_token');
                        AuthorizationStore.removeFromLocalStorage('current_user');
                        AuthorizationStore.removeFromLocalStorage('current_partner');
                        document.location.assign("/login");
                        return;
                    }

                    let data: AzureRefreshTokenRequest = {
                        impactPartnerId: currentPartner?.Id,
                        refreshToken: azureToken.refresh_token
                    }

                    axiosResult = await Axios.post(`/api/Authorization/refreshAzureToken/`, data, axiosRequestConfig);
                    AuthorizationStore.saveAzureTokenToLocalStorage(axiosResult.data.token);
                    token = axiosResult.data.token.access_token;

                } catch {
                    AuthorizationStore.removeFromLocalStorage('azure_ad_token');
                    AuthorizationStore.removeFromLocalStorage('current_user');
                    AuthorizationStore.removeFromLocalStorage('current_partner');
                    document.location.assign("/login");
                }
            }

            axiosRequestConfig.headers.Authorization = 'Bearer '.concat(token);

            let clientToken = "";
            let requestClientToken = false;

            let clientAzureToken = AuthorizationStore.getPartnerAzureTokenFromLocalStorage(partner.FormatedName);

            if (clientAzureToken != null) {
                clientToken = clientAzureToken.access_token;

                if (Date.now() >= clientAzureToken.expires_on * 1000) {
                    requestClientToken = true;
                }
            }
            else {
                requestClientToken = true;
            }

            if (requestClientToken) {
                try {
                    const data: GetAzureClientTokenRequest = {
                        impactPartnerId: partner.Id
                    };

                    axiosResult = await Axios.post(`/api/Authorization/getAzureClientToken/`, data, axiosRequestConfig);
                    AuthorizationStore.savePartnerAzureTokenToLocalStorage(partner.FormatedName, axiosResult.data.token);
                    clientToken = axiosResult.data.token.access_token;

                } catch {

                }
            }

            axiosRequestConfig.headers["Client-Authorization"] = 'Bearer '.concat(clientToken);
            axiosRequestConfig.headers["Azure-Client-Id"] = partner.ClientId;
        }
        else {
            AuthorizationStore.removeFromLocalStorage('azure_ad_token');
            AuthorizationStore.removeFromLocalStorage('current_user');
            AuthorizationStore.removeFromLocalStorage('current_partner');
            document.location.assign("/login");
        }

        var currentUser = AuthorizationStore.getUserFromLocalStorage();

        if (currentUser) {
            axiosRequestConfig.headers["INET-User"] = currentUser.UserId;
            axiosRequestConfig.headers["INET-User-Name"] = normalizeToASCII(currentUser.UserName);
        }

        var payload = opts.data;

        if (useMultiPart === true) {
            axiosRequestConfig.headers.ContentType = 'multipart/form-data';
            payload = convertModelToFormData(opts.data);
        }

        try {
            switch (opts.method) {
                case "GET":
                    axiosResult = await Axios.get(processQuery(opts.url, payload), axiosRequestConfig);
                    break;
                case "POST":
                    axiosResult = await Axios.post(opts.url, payload, axiosRequestConfig);
                    break;
                case "PUT":
                    axiosResult = await Axios.put(opts.url, payload, axiosRequestConfig);
                    break;
                case "PATCH":
                    axiosResult = await Axios.patch(opts.url, payload, axiosRequestConfig);
                    break;
                case "DELETE":
                    axiosResult = await Axios.delete(processQuery(opts.url, payload), axiosRequestConfig);
                    break;
            }

            var rowData = preProcessJson
                ? preProcessJson(axiosResult.data)
                : axiosResult.data;

            result = new Result(rowData, null, null, 200);
            //result = new Result(axiosResult.data, ...axiosResult.data.errors);
        } catch (error) {
            console.warn('Service Base error catch', error);
            if (error.response && error.response.status === 400) {
                console.warn('processing bad request:', error.response);
                return this.createErrorRequestResult(error);
            } else if (error.response && error.response.status === 401) {
                console.warn('processing unauthorized request:', error.response);
                return this.createErrorRequestResult(error);
            } else if (error.response && error.response.status === 500) {
                console.warn('processing server error request:', error.response);
                return this.createErrorRequestResult(error);
            } else {
                console.warn('service unproceessed responce:', error);
            }

            if (error.response) {
                console.log(error.response.data);
                console.log('general error', error.response.data['']);
            }

            result = new Result(null, null, error.message, error.response ? error.response.status : error.__proto__.__CANCEL__ ? 499 : undefined);
            console.log(result)
        }

        if (result.hasErrors) {
            console.log('ServiceBase: Server error');
            //Ui.showErrors('Server error');
        }

        return result;
    }

    private static createErrorRequestResult(error: any) {
        var convertedErrors = convertDictionaryKeysToCamelStyle(error.response.data.errors);

        const data = error.response.data;
        const status = error.response.status;
        let errorMessage = (typeof data == 'string' && data.length > 0) ? data : error.message;

        if (data.title) {
            errorMessage = data.title;
        }
        else if (data.error_description) {
            errorMessage = data.error_description;
        }
        else if (data.ErrorMessage)
        {
            try {
                const errorObj = JSON.parse(data.ErrorMessage);
                errorMessage = errorObj.message || "";
            } catch {
                errorMessage = data.ErrorMessage;
            }
        }

        return new Result(null, convertedErrors, errorMessage, status);
    }

    private static createBadRequestResult(error: any) {
        var convertedErrors = convertDictionaryKeysToCamelStyle(error.response.data.errors);

        const data = error.response.data;
        const status = error.response.status;
        let errorMessage = (typeof data == 'string' && data.length > 0) ? data : error.message;

        if (data.title) {
            errorMessage = data.title;
        }
        else if (data.error_description) {
            errorMessage = data.error_description;
        }

        return new Result(null, convertedErrors, errorMessage, status);
    }

    /**
     * Make request with JSON data.
     * @param opts
     */
    public static async requestNotAuthJson<T>(opts: IRequestOptions, preProcessJson?: (data: any) => any, useMultiPart?: boolean): Promise<Result<T>> {

        var axiosResult = null;
        var result = null;

        //opts.url = transformUrl(opts.url); // Allow requests also for the Node.

        var processQuery = (url: string, data: any): string => {
            if (data) {
                return `${url}?${jsonToUrl(data)}`;
            }
            return url;
        };

        var axiosRequestConfig: AxiosRequestConfig = {
            headers: {}
        };

        var payload = opts.data;

        if (useMultiPart === true) {
            axiosRequestConfig.headers.ContentType = 'multipart/form-data';
            payload = convertModelToFormData(opts.data);
        }

        try {
            switch (opts.method) {
                case "GET":
                    axiosResult = await Axios.get(processQuery(opts.url, payload), axiosRequestConfig);
                    break;
                case "POST":
                    axiosResult = await Axios.post(opts.url, payload, axiosRequestConfig);
                    break;
                case "PUT":
                    axiosResult = await Axios.put(opts.url, payload, axiosRequestConfig);
                    break;
                case "PATCH":
                    axiosResult = await Axios.patch(opts.url, payload, axiosRequestConfig);
                    break;
                case "DELETE":
                    axiosResult = await Axios.delete(processQuery(opts.url, payload), axiosRequestConfig);
                    break;
            }

            var rowData = preProcessJson
                ? preProcessJson(axiosResult.data)
                : axiosResult.data;

            result = new Result(rowData, null, null, 200);
            //result = new Result(axiosResult.data, ...axiosResult.data.errors);
        } catch (error) {

            console.warn('Service Base error catch', error);

            if (error.response.status == 400) {

                console.warn('processing bad request:', error.response);
                return this.createBadRequestResult(error);

                //} else if (error.response.status == 401) {
                //    let errorMessage = "";
                //    if (error.response.data.title) {
                //        errorMessage = error.response.data.title;
                //    }
                //    else if (error.response.data.error_description) {
                //        errorMessage = error.response.data.error_description
                //    }

                //    result = new Result(null, null, errorMessage, error.response.status);
            } else {
                console.warn('service unproceessed responce:', error);
            }

            if (error.response) {
                console.log(error.response.data);
                console.log('general error', error.response.data['']);
            }

            console.log('axiosResult error', error);
            console.log('axiosResult error.response', error.response);
            result = new Result(null, null, error.message, error.response.status);
        }

        if (result.hasErrors) {
            console.log('ServiceBase: Server error');
            //Ui.showErrors('Server error');
        }

        return result;
    }

    // Generic retry helper with exponential backoff + full jitter.
    // - fn: async function that performs the request
    // - attempts: total attempts (default 3)
    // - baseDelayMs: base delay in milliseconds (default 500)
    // If fn throws, retry will attempt again. For POST operations that are NOT idempotent,
    // keep attempts = 1 to avoid duplicate side-effects.
    public static async retry<T>(
        fn: () => Promise<Result<T>>,
        attempts: number = 2,
        baseDelayMs: number = 500
    ): Promise<Result<T>> {
        let lastError: any = null;

        for (let attempt = 1; attempt <= attempts; attempt++) {
            try {
                return await fn();
            } catch (err) {
                lastError = err;

                // If this was the last attempt, rethrow
                if (attempt === attempts) {
                    throw err;
                }

                // Exponential backoff with full jitter:
                // cap = baseDelayMs * 2^(attempt-1)
                const cap = baseDelayMs * Math.pow(2, attempt - 1);
                const jitterDelay = Math.floor(Math.random() * cap);

                // Optionally you can log here if you have a logging facility:
                // console.warn(`Retry ${attempt}/${attempts} after error, waiting ${jitterDelay}ms`, err);

                await new Promise<void>((resolve) => setTimeout(resolve, jitterDelay));
            }
        }

        // Should not reach here, but rethrow just in case
        throw lastError;
    }
}

function convertModelToFormData(model: any, form: FormData = null, namespace = ''): FormData {
    let formData = form || new FormData();
    let formKey;

    // check if it is primitive
    if (model !== Object(model)) {
        let formKey = namespace;
        formData.append(formKey, model.toString());

    } else {
        for (let propertyName in model) {
            if (!model.hasOwnProperty(propertyName) || !model[propertyName]) continue;
            let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
            if (model[propertyName] instanceof Date)
                formData.append(formKey, model[propertyName].toISOString());
            else if (model[propertyName] instanceof Array) {
                model[propertyName].forEach((element, index) => {
                    const tempFormKey = `${formKey}[${index}]`;
                    convertModelToFormData(element, formData, tempFormKey);
                });
            }
            else if (typeof model[propertyName] === 'object' && !(model[propertyName] instanceof File))
                convertModelToFormData(model[propertyName], formData, formKey);
            else {
                if (model[propertyName] instanceof File) {
                    formData.append(formKey, model[propertyName]);
                } else {
                    formData.append(formKey, model[propertyName].toString());
                }
            }
        }
    }

    return formData;
}

function convertDictionaryKeysToCamelStyle(input: any) {

    if (!input)
        return input;

    var newResult = {};
    var x;
    for (x in input) {

        var propName = convertStringToCamelCase(x);
        var propValue = input[x];

        var newObjProp = {};
        newObjProp[propName] = propValue;
        newResult[convertStringToCamelCase(x)] = input[x];
    }

    //console.log('convertDictionaryKeysToCamelStyle input: ', input);
    //console.log('convertDictionaryKeysToCamelStyle output: ', newResult);

    return newResult;
}

function convertStringToCamelCase(input: string) {

    if (!input)
        return input;

    if (input.length === 1)
        return input.toLowerCase();

    return input[0].toLowerCase() + input.substring(1);
}

function normalizeToASCII(input: string) {
    return input.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

class Sorting {
    column: string;
    sortAsc: boolean;

    constructor() {
        this.column = '';
        this.sortAsc = true;
    }
}

export { Result, PagedResult, Sorting };